rs.module("controls/diagnostics/debugpane",

    [
        "controls/diagnostics/facadeviewer-factory",
        "ui/framework/userstate-manager",
        "ui/framework/client-templates"
    ],

    function (facadeViewerFactory, userStateManager, clientTemplates) {

        var _debugPane = null;
        var _started = false;
        var _facadeViewerInstanceName = null;
        var _jsSelectors = null;
        var _cssClasses = null;
        var _clientTemplateKeys = null;
        var _userStateKeys = null;
        var _onInitializingCallback = null;

        // Initialize the menu
        function initialize(jsSelectors, cssClasses, userStateKeys, clientTemplateKeys, facadeViewerInstanceName, forceValidationCookieName, pathBase, isPaneOpen) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _clientTemplateKeys = clientTemplateKeys;
            _facadeViewerInstanceName = facadeViewerInstanceName;
            _userStateKeys = userStateKeys;
            _debugPane = $.js(_jsSelectors.debugPane);

            // fire the callback if one is registered
            if (_onInitializingCallback) {
                _onInitializingCallback.call();
            }

            var forceModelStateInvalidCheckbox = _debugPane.js(_jsSelectors.forceModelStateInvalid);
            var disableClientValidationsButton = _debugPane.js(_jsSelectors.disableClientValidations);

            // if the force validation cookie exists, set the checkbox as checked.  
            if (Cookies.get(forceValidationCookieName)) {
                forceModelStateInvalidCheckbox.setChecked(true);
            }

            // Handle the checking/unchecking of the force validation checkbox
            forceModelStateInvalidCheckbox.on("click", function () {
                // These options need to match the options set server-side in order for the server-side
                // cookie delete to work.
                var cookieOptions = {
                    secure: true,
                    domain: '.' + window.location.hostname,
                    path: pathBase
                };

                if ($(this).is(":checked")) {
                    // no expiration so it's a session cookie
                    Cookies.set(forceValidationCookieName, 'true', cookieOptions);
                }
                else {
                    Cookies.remove(forceValidationCookieName, cookieOptions);
                }
            });

            // Handle clicking of the disable validations button
            disableClientValidationsButton.on("click", function () {

                // Configure our custom validation ignoring to ignore everything
                $.validator.ignore(function (index, element) {
                    return true;
                });

                // wipe out the validation include list so everything is ignored
                $.validator.include.list = [];

                // disable the button
                $(this).prop("disabled", true);
            });

            // if we're starting visible, start listening for facade messages
            if (isPaneOpen) {
                ensureFacadeViewerStarted();
            }

            $(document).ready(function () {
                loadPerformanceData();
            });
        }

        function loadPerformanceData() {
            if (window.performance) {

                var metrics = [];

                var timing = window.performance.getEntriesByType("navigation")[0];

                metrics.push({
                    name : "Total",
                    value: $.format.number(timing.responseStart - timing.requestStart, '#,##0.##'),
                    unit: "ms.",
                    browser: true
                });

                // domContentLoaded duration - per mozilla, this should be kept under 50ms to feel responsive.
                metrics.push({
                    name : "domContentLoaded",
                    value : $.format.number(timing.domContentLoadedEventEnd - timing.domContentLoadedEventStart, '#,##0.##'),
                    unit: "ms.",
                    browser: true
                });
                
                metrics.push({
                    name : "HTML size",
                    value : $.format.number(timing.decodedBodySize, '#,###'),
                    unit: "bytes",
                    browser: true
                });

                var serverTiming = timing.serverTiming;
                for (let i = 0; i < serverTiming.length; i++) {
                    metrics.push({
                        name: serverTiming[i].description,
                        value: $.format.number(serverTiming[i].duration, '#,##0.##'),
                        unit: "ms."
                    });
                }

                // render and stick on page
                var content = clientTemplates.render(_clientTemplateKeys.metrics, { "metrics": metrics });
                $.js(_jsSelectors.metrics).html(content);
            }
        }

        // Register an initialization callback
        function onInitializing(callback) {
            _onInitializingCallback = callback;
        }

        // Get the visibility of the pane
        function getVisible() {
            return _debugPane.hasClass(_cssClasses.visible);
        }

        // Set the visibility of the pane
        function setVisible(visible) {
            _debugPane.toggleClass(_cssClasses.visible, visible);

            // make sure the facade viewer is listening for messages
            if (visible) {
                ensureFacadeViewerStarted();
            }

            // we're saving state so it can remain open between pages
            userStateManager.persist(_userStateKeys.paneOpenStateKey, visible);
        }

        // Starts listening for facade messages if the window is visible and it's not already listening
        function ensureFacadeViewerStarted() {

            if (!_started) {
                _started = true;

                facadeViewerFactory.getViewer(_facadeViewerInstanceName).start();
            }
        }

        var exports = {
            initialize: initialize,
            onInitializing: onInitializing
        };

        Object.defineProperty(exports, "visible",
            {
                get: getVisible,
                set: setVisible
            });

        return exports;
    }
);